import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DomainSetting } from "./types";

interface DomainSettingsState {
  domainDetails: DomainSetting[] | null;
}

const initialState: DomainSettingsState = {
  domainDetails: null,
};

const domainSettingsSlice = createSlice({
  name: "domainSettings",
  initialState,
  reducers: {
    setDomainSettingsDetails: (
      state,
      action: PayloadAction<DomainSetting[]>
    ) => {
      state.domainDetails = action.payload;
    },
  },
});

export const { setDomainSettingsDetails } = domainSettingsSlice.actions;

export const selectDomainDetails = (state: any): DomainSetting[] | null =>
  state.domainSettings.domainDetails;

export default domainSettingsSlice;
